export default __webpack_public_path__ + "static/media/bloodyhack4.26ad8367.png";